import { useEffect } from "react";

const CertificationProgress = ({ certificationType, steps, activeStep, helpUrl }) => {
  const activeStepIndex = Math.max(steps.findIndex((step) => step.id === activeStep), 0);
  const activeStepDetails = steps[activeStepIndex];
  const phaseLabel = `${activeStepDetails.label}, step ${activeStepIndex + 1} of ${steps.length}`;

  useEffect(() => {
    document.title = `${certificationType} Certification - ${activeStepDetails.label} | EEPASS`;
    return () => {
      document.title = "EEPASS";
    };
  }, [certificationType, activeStepDetails.label]);

  return (
    <div className="certification-progress-wrapper">
      <nav className="certification-progress" aria-label={`${certificationType} certification progress`}>
        <ol>
          {steps.map((step, index) => (
            <li key={step.id} aria-current={step.id === activeStep ? "step" : undefined}>
              <span className="certification-progress-step">{index + 1}</span>
              <span className="certification-progress-label">{step.label}</span>
            </li>
          ))}
        </ol>
      </nav>
      <p className="certification-phase-status" role="status" aria-live="polite" aria-atomic="true">
        {phaseLabel}
      </p>
      {helpUrl && (
        <a href={helpUrl} target="_blank" rel="noreferrer">
          Online Certification User Guide (opens in a new tab)
        </a>
      )}
    </div>
  );
};

export default CertificationProgress;
